import { render, staticRenderFns } from "./CmAbstract.vue?vue&type=template&id=152ab39c"
import script from "./CmAbstract.vue?vue&type=script&lang=ts"
export * from "./CmAbstract.vue?vue&type=script&lang=ts"
import style0 from "./CmAbstract.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports